<template>
  <ContentPage back>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">W9 Request</div>
    </template>

    <Section>
      <v-form ref="form" @submit.prevent="submitClick">
        <v-text-field 
          outlined dense validate-on-blur
          v-model="name" label="Name"
          :rules="[required]"
        />
        <v-text-field
          outlined dense validate-on-blur
          v-model="street" label="Street"
          :rules="[required]"
        />
        <v-text-field
          outlined dense validate-on-blur
          v-model="city" label="City"
          :rules="[required]"
        />
        <div class="d-flex">
          <StateSelect
            outlined dense validate-on-blur
            v-model="state" label="State"
            :rules="[required]"
          />

          <v-text-field
            outlined dense validate-on-blur class="ml-2"
            v-model="zipcode" label="Zip Code"
            v-mask="'#####'"
            :rules="[required]"
          />
        </div>
        <v-text-field
          outlined dense validate-on-blur
          v-model="ssn" label="SSN"
          v-mask="'###-##-####'"
          :rules="[required, validSSN]"
        />
        <div class="d-flex" style="position: relative">
          <VueSignaturePad
            ref="signaturePad" 
            height="125px"
            class="rounded"
            style="border: black 1px solid; background-color: #EEEEEE;"
            :options="options"
          />
          <v-icon 
            style="position: absolute; right: 0px;" 
            color="dark grey"
            class="ma-1"
            @click="resetSignature"
          >
            mdi-close-box
          </v-icon>
          <div
            v-if="signatureValid"
            style="font-size: 14px; position: absolute; bottom: 4px; width: 100%"
            class="text-center grey--text font-italic"
          >
            sign here
          </div>
          <div 
            v-else style="font-size: 14px; position: absolute; bottom: 4px; width: 100%"
            class="text-center red--text font-italic"
          >
            signature required
          </div>
        </div>

        <div class="mt-3 d-flex justify-center">
          <v-btn class="ml-3" color="primary" type="submit">Save</v-btn>
        </div>
      </v-form>
    </Section>
  </ContentPage>
</template>

<script>
import { ContentPage, Section } from '@/components/pages'
import StateSelect from '@/components/inputs/StateSelect'
import { required } from '@/lib/validations'
import { mapActions } from 'vuex'

export default {
  name :'W9FormPage',

  components: { ContentPage, Section, StateSelect },

  data: () => ({
    business_name: '',
    street: '',
    city: '',
    state: '',
    zipcode: '',
    ssn: '',
    entity_type: '',

    signatureValid: true,

    options: {
      penColor: 'blue',
    },

    // validations
    required,
    validSSN: v => v.match(/\d\d\d-\d\d-\d\d\d\d/) != null || 'expecting ###-##-####'
  }),

  methods: {
    ...mapActions('auth', ['createW9']),

    resetSignature() {
      this.$refs.signaturePad.clearSignature()
    },

    async submitClick() {
      if (this.$refs.signaturePad.isEmpty()) {
        this.signatureValid = false
        this.$refs.form.validate()
        return
      }
      this.signatureValid = true

      if (this.$refs.form.validate()) {
        const { name, street, city, state, zipcode, ssn } = this
        
        const signature = this.$refs.signaturePad.saveSignature().data
        const payload = { name, street, city, state, zipcode, signature, ssn }

        const result = await this.createW9(payload)
        if (result.ok) {
          this.$router.replace({ name: 'w9/thanks' })
        }
      }
    },
  }
}
</script>

